<sh-table [class.table-height]="expanded() && parts().length > 0">
  <sh-table-row slot="header">
    @for (item of columnsDefinition(); track $index) {
      <sh-table-head
        [columns]="item.columns"
        [attr.min-width]="item.minWidth"
        (toggle)="
          toggleSort(
            item.property,
            $event.target.hasAttribute('sort-descending')
          )
        "
      >
        {{ item.label | translate }}
      </sh-table-head>
    }
  </sh-table-row>
  @for (part of parts(); track $index + part.creationDate) {
    <sh-table-row>
      @for (item of columnsDefinition(); track $index) {
        @switch (item.property) {
          @case ('creationDate') {
            <sh-table-cell
              [columns]="item.columns"
              [class]="item.property"
              [attr.min-width]="item.minWidth"
            >
              {{ part.creationDate | localizedDate }}
            </sh-table-cell>
          }
          @case ('ticketNumber') {
            <sh-table-cell
              [columns]="item.columns"
              [class]="item.property"
              [attr.min-width]="item.minWidth"
            >
              <span class="ticket-number">
                <span>
                  {{ part.ticketNumber }}
                </span>
                <sh-icon
                  icon="copy-results-to-clipboard"
                  color="#7D7D7D"
                  aria-label="{{
                    'spareParts.ariaLabel.copyClipboard' | translate
                  }}"
                  size="s"
                  button
                  (click)="clipboardService.copyToClipboard(part.ticketNumber)"
                  (keydown.enter)="
                    clipboardService.copyToClipboard(part.ticketNumber)
                  "
                  (keydown.space)="
                    clipboardService.copyToClipboard(part.ticketNumber)
                  "
                ></sh-icon>
              </span>
            </sh-table-cell>
          }
          @case ('partDescription') {
            <sh-table-cell
              class="part-description"
              [columns]="item.columns"
              [class]="item.property"
              [attr.min-width]="item.minWidth"
            >
              <div
                #partDescription
                class="part-description-text"
                matTooltip="{{ part.partDescription }}"
                matTooltipClass="sp-service-ticket-tooltip"
                matTooltipPosition="above"
                [matTooltipDisabled]="!hasOverflow(partDescription)"
              >
                {{ part.partDescription }}
              </div>
            </sh-table-cell>
          }
          @case ('partNumber') {
            <sh-table-cell
              [columns]="item.columns"
              [class]="item.property"
              [attr.min-width]="item.minWidth"
            >
              <span class="ticket-number">
                <span>
                  {{ part.partNumber }}
                </span>
                <sh-icon
                  icon="copy-results-to-clipboard"
                  color="#7D7D7D"
                  aria-label="{{
                    'spareParts.ariaLabel.copyClipboard' | translate
                  }}"
                  size="s"
                  button
                  (click)="clipboardService.copyToClipboard(part.partNumber)"
                  (keydown.enter)="
                    clipboardService.copyToClipboard(part.partNumber)
                  "
                  (keydown.space)="
                    clipboardService.copyToClipboard(part.partNumber)
                  "
                ></sh-icon>
              </span>
            </sh-table-cell>
          }
          @case ('partStatus') {
            <sh-table-cell
              [columns]="item.columns"
              [class]="item.property"
              [attr.min-width]="item.minWidth"
            >
              <app-part-status-info
                [partStatus]="part.partStatus"
              ></app-part-status-info>
            </sh-table-cell>
          }
          @default {
            <sh-table-cell
              [columns]="item.columns"
              [class]="item.property"
              [attr.min-width]="item.minWidth"
            >
              {{ part[item.property] }}
            </sh-table-cell>
          }
        }
      }
    </sh-table-row>
  }
</sh-table>
